import { useStaticQuery, graphql } from 'gatsby';
import * as JsSearch from 'js-search';
import markdownToTxt from 'markdown-to-txt';
import _ from 'lodash';
import { normalizeNavigatePath } from './NavPathUtil';
import { cleanString } from './TextDecoratorUtil';

export const useSearchContent = () => {
  const { allSanityPost: { edges } } = useStaticQuery(
    graphql`
      query {
        allSanityPost {
          edges {
            node {
              id
              title,
              category {
                category
              },
              slug {
                current
              },
              _rawBody
            }
          }
        }
      }
      `
  )
  const preparedData = flattenContent(edges);
  // Js Search instance
  const jsSearch = new JsSearch.Search('objectID');

  // Add what data to be searhced
  jsSearch.addIndex('title');
  jsSearch.addIndex('content');
  jsSearch.addIndex('category');

  // Add documents to search instance
  jsSearch.addDocuments([...preparedData]);

  return jsSearch;
}

const flattenContent = (arr = []) => arr.map(({ node }) => {
  const content = [];
  if (node._rawBody) {   
    node._rawBody.forEach((e) => {
      if (e.answer) {
        content.push(_.unescape(cleanString(e.answer)));
      }
      if (e.question) {
        content.push(_.unescape(cleanString(e.question)));
      }
      if (e.title) {
        content.push(_.unescape(e.title));
      }
      if (e.message) {
        content.push(_.unescape(cleanString(e.message)));
      }
      if (e.link) {
        content.push(_.unescape(e.link));
      }
      if (e.description) {
        content.push(_.unescape(cleanString(e.description)));
      }
      if (e.markdownBody) { 
        content.push(_.unescape(markdownToTxt(e.markdownBody)));
      }
      if (e.children && Array.isArray(e.children)) {
        e.children.forEach((q) => {
          if (q.text) {
            content.push(_.unescape(cleanString(q.text)));
          }
        });
      }
    });
  }
  return {
    objectID: node.id,
    url: normalizeNavigatePath(`wiki/${_.toLower(node.category.category).replace(/\s/g, '-')}/${_.toLower(node.slug.current)}`),
    title: node.title,
    slug: node.slug.current,
    category: node.category.category,
    content,
    rawContent: node._rawBody
  };
});